import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    setVehicleInfo,
    selectVehicleInfo,
    setSavedAssets,
    setIsLoadingSavedAssets,
    updateSavedAssetCallStatus,
} from '@/store/modules/savedVehicleSlice';
import { useRouter } from 'next/router';
import { getSavedAssets } from '../api';
import useSwr from 'swr';
import { IVehicleDetails } from '@/types';
import Router from '@/components/common/router';

interface MMVDetails {
    model_id: number;
    model: string;
    car_age?: number;
    color?: string;
    fuel_type: string;
    make?: string;
    variant_id?: string;
    variant_name?: string;
}

interface VehicleInfo {
    carNumber: string | null;
    vehicleDetails: MMVDetails | null;
    hasSavedVehicle: boolean;
    savedAssets: IVehicleDetails;
    savedAssetError: Error | null;
    isLoadingSavedAssets: boolean;
}

const ONE_DAY_IN_SECONDS = 86400;

const useSavedVehicleInfoCheck = () => {
    const dispatch = useDispatch();
    const vehicleInfo = useSelector(selectVehicleInfo);
    const router = useRouter();
    const shouldFetchSavedAssets = vehicleInfo.shouldFetchSavedAssets;
    console.log({ vehicleInfo });
    //const [isLoadingSavedAssets, setIsLoadingSavedAssets] = useState(false);
    // const [savedAssetsError, setSavedAssetsError] = useState<Error | null>(
    //     null
    // );

    const fetchKey = shouldFetchSavedAssets ? 'saved-assets' : undefined;
    const {
        data,
        error: savedAssetsError,
        isValidating: isLoadingSavedAssets,
    } = useSwr<IVehicleDetails[], Error>(fetchKey, getSavedAssets, {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshInterval: ONE_DAY_IN_SECONDS * 1000,
        shouldRetryOnError: false,
    });

    useEffect(() => {
        if (data && data.length > 0) {
            console.log('debug1', data);
            console.log('Success data:', data);
            const combinedAssets = [
                ...(vehicleInfo.savedAssets || []),
                ...data,
            ];
            const uniqueAssets = removeDuplicateAssets(combinedAssets);
            console.log('Unique assets:', uniqueAssets);
            dispatch(setSavedAssets(uniqueAssets));
            dispatch(updateSavedAssetCallStatus(false));
        }
    }, [data, vehicleInfo.carNumber]);

    // const fetchSavedAssets = async () => {
    //     try {
    //         setIsLoadingSavedAssets(true);
    //         const data = await getSavedAssets();
    //         const combinedAssets = [
    //             ...(vehicleInfo.savedAssets || []),
    //             ...data,
    //         ];
    //         const uniqueAssets = removeDuplicateAssets(combinedAssets);
    //         dispatch(setSavedAssets(uniqueAssets));
    //         setSavedAssetsError(null);
    //     } catch (error) {
    //         console.error('Error fetching saved assets:', error);
    //         setSavedAssetsError(error as Error);
    //     } finally {
    //         setIsLoadingSavedAssets(false);
    //         dispatch(updateSavedAssetCallStatus(false));
    //     }
    // };

    // useEffect(() => {
    //     if (shouldFetchSavedAssets) {
    //         if (isLoadingSavedAssets) return;
    //         fetchSavedAssets();
    //     }
    // }, [shouldFetchSavedAssets]);

    // LocalStorage Check - Run once on component mount
    const checkLocalStorageOnce = useCallback(() => {
        const mmvString = localStorage.getItem('mmv');
        const registrationNumber = localStorage.getItem('registration_number');
        const vehicleSelected = localStorage.getItem('vehicleSelected');

        let vehicleDetails: MMVDetails | null = null;
        if (mmvString) {
            try {
                const parsedMMV: MMVDetails = JSON.parse(mmvString);
                if (
                    typeof parsedMMV.model_id === 'number' &&
                    typeof parsedMMV.model === 'string'
                ) {
                    vehicleDetails = parsedMMV;
                }
            } catch (error) {
                console.error('Error parsing MMV JSON:', error);
            }
        }

        const hasSavedVehicle =
            !!registrationNumber && !!vehicleSelected && !!vehicleDetails;

        dispatch(
            setVehicleInfo({
                carNumber: registrationNumber,
                vehicleDetails,
                hasSavedVehicle,
            })
        );
    }, [dispatch]);

    const checkAndUpdateVehicleInfo = useCallback(() => {
        const { carNumber, savedAssets, vehicleDetails } = vehicleInfo;

        // router.replace(
        //     {
        //         pathname: `${process.env.NEXT_PUBLIC_ENV_PREFIX}${router.pathname}`,
        //         query: { ...router.query, carnumber: carNumber },
        //     },
        //     undefined,
        //     { shallow: true }
        // );

        if (vehicleDetails && carNumber) {
            console.log('debug', vehicleDetails);
            const localSavedData = {
                vehicle_make: vehicleDetails.make,
                vehicle_model: vehicleDetails.model,
                vehicle_name: '',
                vehicle_number: carNumber,
                variant_id: vehicleDetails?.variant_id || '',
                variant_name: vehicleDetails?.variant_name || '',
                fuel_type: vehicleDetails?.fuel_type || '',
            };

            const combinedSavedAssets = [
                localSavedData,
                ...(savedAssets || []),
            ];

            // Remove duplicates based on vehicle_number
            const uniqueSavedAssets =
                removeDuplicateAssets(combinedSavedAssets);
            dispatch(setSavedAssets(uniqueSavedAssets));
        }
    }, [vehicleInfo.carNumber]);

    // const checkAndUpdateVehicleInfo = useCallback(() => {
    //     // if (typeof window === 'undefined' || !router.pathname.includes('/ad-services')) {
    //     //   dispatch(clearVehicleInfo());
    //     //   return;
    //     // }
    //     console.log('change vehicle details', vehicleInfo);

    //     const mmvString = localStorage.getItem('mmv');
    //     const registrationNumber = localStorage.getItem('registration_number');
    //     const vehicleSelected = localStorage.getItem('vehicleSelected');

    //     let vehicleDetails: MMVDetails | null = null;
    //     if (mmvString) {
    //         try {
    //             const parsedMMV: MMVDetails = JSON.parse(mmvString);
    //             if (
    //                 typeof parsedMMV.model_id === 'number' &&
    //                 typeof parsedMMV.model === 'string'
    //             ) {
    //                 vehicleDetails = parsedMMV;
    //             }
    //         } catch (error) {
    //             console.error('Error parsing MMV JSON:', error);
    //         }
    //     }

    //     const hasSavedVehicle =
    //         !!registrationNumber && !!vehicleSelected && !!vehicleDetails;

    //     dispatch(
    //         setVehicleInfo({
    //             carNumber: registrationNumber,
    //             vehicleDetails,
    //             hasSavedVehicle,
    //         })
    //     );
    //     if (
    //         registrationNumber &&
    //         registrationNumber !== vehicleInfo.carNumber
    //     ) {
    //         router.replace(
    //             {
    //                 pathname: `${process.env.NEXT_PUBLIC_ENV_PREFIX}${router.pathname}`,
    //                 query: { ...router.query, carnumber: registrationNumber },
    //             },
    //             undefined,
    //             { shallow: true }
    //         );
    //     }

    // }, [dispatch, router.pathname]);

    // Run localStorage check once on component mount
    useEffect(() => {
        checkLocalStorageOnce();
    }, []);

    // Run vehicle info check on carNumber change
    useEffect(() => {
        if (vehicleInfo.carNumber) {
            checkAndUpdateVehicleInfo();
        }
    }, [vehicleInfo.carNumber]);

    return {
        ...vehicleInfo,
        isLoadingSavedAssets: isLoadingSavedAssets,
        savedAssetsError: savedAssetsError || null,
    };
};

export default useSavedVehicleInfoCheck;

const removeDuplicateAssets = (assets: IVehicleDetails[]) => {
    return assets.filter(
        (value, index, self) =>
            index ===
            self.findIndex(
                (item) => item.vehicle_number === value.vehicle_number
            )
    );
};
